export default function Footer() {
  const footerLinks = {
    '浏览导航': [
      { label: '今日精选', href: '#cards' },
      { label: '精彩专题', href: '#carousel' },
      { label: '影视索引', href: '#index' },
      { label: '热播排行', href: '#ranking' },
      { label: '精选视频', href: '#media' },
    ],
    '关于我们': [
      { label: '平台介绍', href: '#about' },
      { label: '投稿合作', href: '#contact' },
      { label: '常见问题', href: '#faq' },
      { label: '移动客户端', href: '#app' },
    ],
  };

  return (
    <footer id="footer" className="bg-background-900 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-white text-xl"></i>
              </div>
              <span className="text-lg font-bold text-white">青柠影视</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              青柠影视 - 免费高清在线追剧平台，海量影视资源每日更新。无需付费即可享受高清画质与极速播放，让每个人都能轻松追剧看片。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200 cursor-pointer no-underline">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200 cursor-pointer no-underline">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-all duration-200 cursor-pointer no-underline">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <h4 className="text-sm font-bold text-white mb-4">{group}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer no-underline"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-background-300 leading-relaxed">
              期待与更多优秀内容方合作，共同为用户提供更丰富的影视资源。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 青柠影视. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer no-underline">服务条款</a>
            <a href="#hero" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer no-underline">隐私政策</a>
            <a href="#hero" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer no-underline">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}